// رأس تقرير الرواتب + البطاقات الإحصائية.
import { esc, formatCurrency, today } from "./reportFormat";
import { brandLogo, brandName } from "./reportBrand";
import { sealQr } from "./sealQr";
import { printButton } from "../reports/reportButtons";

const card = (label, value, tone = "") =>
  `<div class="card"><div class="label">${esc(label)}</div><div class="value ${tone}">${esc(value)}</div></div>`;

const tone = (value) => (Number(value) < 0 ? "negative" : Number(value) > 0 ? "positive" : "");

export const header = (data, L, { custom, brand }) => {
  const one = data.employees.length === 1;
  const title = custom ? L.titleCustom : one ? L.titleOne : L.titleMany;
  const subtitle = one ? data.employees[0].employee_name : data.branch_name || L.allBranches;
  const month = `${String(data.accounting_month).padStart(2, "0")}/${data.accounting_year}`;
  const range = `${data.period_start} ${L.periodTo} ${data.period_end}`;
  const perBranch = (data.branch_periods || []).length > 1
    ? `<p>${data.branch_periods
        .map((b) => `${esc(b.branch_name)}: ${b.period_start} → ${b.period_end}` +
          (b.payroll_day ? ` (${esc(L.payDay)} ${b.payroll_day})` : ""))
        .join(" · ")}</p>`
    : "";
  return `<div class="header">
    ${brandLogo(brand)}
    ${brandName(brand)}
    ${data.sealed ? `<div class="seal">${esc(L.sealedBadge)} · ${esc(String(data.sealed_at || "").slice(0, 10))}</div>` : ""}
    <h1>${esc(title)}</h1>
    <h2>${esc(subtitle)}</h2>
    ${custom
      ? `<p class="period">${esc(range)} (${data.period_days} ${esc(L.days)})</p>`
      : `<p>${esc(L.month)}: ${esc(month)}</p><p class="period">${esc(range)}</p>
         <p class="period">${esc(L.dayOf)} ${data.current_day} / ${data.days_in_month}${
          data.compensation_days ? ` · ${esc(L.compNote)} ${data.compensation_days}` : ""
        }</p>`}
    ${perBranch}
    ${one ? `<p>${esc(data.employees[0].branch_name)}</p>` : ""}
    <p>${esc(L.generatedAt)}: ${today()}</p>
    ${sealQr(data, L)}
  </div>`;
};

export const cards = (data, L, { custom }) => {
  const t = data.totals;
  const c = data.currency;
  const rows = custom
    ? [
        card(L.cardsCustom[0], t.employees),
        card(L.cardsCustom[1], formatCurrency(t.base_salary, c)),
        card(L.cardsCustom[2], formatCurrency(t.allowances, c)),
        card(L.cardsCustom[3], formatCurrency(t.accumulated, c), tone(t.accumulated)),
      ]
    : [
        card(L.cards[0], t.employees),
        card(L.cards[1], formatCurrency(t.base_salary, c)),
        card(L.cards[2], formatCurrency(t.accumulated, c), tone(t.accumulated)),
        card(L.cards[3], formatCurrency(t.expected_end_of_month, c)),
      ];
  return `<div class="cards">${rows.join("")}</div>`;
};

export const buttons = (L, share = null, pdfUrl = null) =>
  `<div class="pdf-bar">
    ${printButton(L)}
    ${pdfUrl ? `<button class="btn-pdfshare" data-testid="report-share-pdf" onclick="shareReportPdf()">${esc(L.sharePdf)}</button>` : ""}
    ${share?.url ? `<button class="btn-copy" data-testid="report-copy-top" onclick="copyReportLink('${esc(share.short || share.url)}')">${esc(L.copyLink)}</button>` : ""}
    <button class="btn-close" data-testid="report-close" onclick="reportClose()">${esc(L.close)}</button>
  </div>`;
